﻿import { IRegionalAdministratorsResponse } from "../../Model/Region";
import { RESTError } from "../RESTError";
import { UserAccountSet } from "./UserAccountSet";

var BASE_URL = '/api/Users';

export enum DownloadPermissionType {
    None,
    Regional,
    All
}

export enum MetnetSpatialPermissions {
    None,
    User,
    Administrator
}

export enum DigitalWeatherPermissions {
    None,
    User,
    Essential
}

export interface UserTokenValidity {
    IsValid: boolean;
    Message: string;
    UserAccountId: string | null;
    Expires: number | null;
}

export function getUsers(callback: (err: any, data: UserAccountSet) => any): void {
    $.ajax(BASE_URL + '', {
        cache: false,
        dataType: 'json',
        type: 'GET',
        timeout: 30000,
        success: (data: UserAccountSet, text: string, jqXHR: JQueryXHR) => {
            callback(null, data);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(errorThrown, null);
        }
    });
}

export function register(email: string, password: string, shellEmail: boolean, callback: (RESTError: any) => any): void {
    $.ajax(BASE_URL + '/Register', {
        cache: false,
        type: 'POST',
        data: {
            "Email": email,
            "Password": password,
            "ShellEmail": shellEmail
        },
        timeout: 30000,
        success: (data: any, text: string, jqXHR: JQueryXHR) => {
            callback(null);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR));
        }
    });
}

export function createNewUser(email: string, region: string, admin: boolean, globalAdmin: boolean, metnetSpatialPermissions: MetnetSpatialPermissions,
    digitalWeatherPermissions: DigitalWeatherPermissions,
    userExpiry: number, callback: (RESTError: any) => any): void {
    $.ajax(BASE_URL + '/CreateNewUser', {
        cache: false,
        type: 'POST',
        data: {
            "Email": email,
            "Region": region,
            "Admin": admin,
            "GlobalAdmin": globalAdmin,
            "DownloadPermission": DownloadPermissionType.All,
            "UserExpiry": userExpiry,
            "SingleRegionPermission": false,
            "MetnetSpatialPermissions": metnetSpatialPermissions,
            "DigitalWeatherPermissions": digitalWeatherPermissions
        },
        timeout: 30000,
        success: (data: any, text: string, jqXHR: JQueryXHR) => {
            callback(null);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR));
        }
    });
}

export function deleteUser(email: string, callback: (RESTError: any) => any): void {
    $.ajax(BASE_URL + '/DeleteUser', {
        cache: false,
        type: 'POST',
        data: {
            "Email": email
        },
        timeout: 30000,
        success: (data: any, text: string, jqXHR: JQueryXHR) => {
            callback(null);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR));
        }
    });
}

export function resetPassword(email: string, oldPassword: string, newPassword: string, callback: (err: RESTError) => any): void {
    $.ajax(BASE_URL + '/ResetPassword', {
        cache: false,
        type: 'POST',
        data: {
            "Email": email,
            "OldPassword": oldPassword,
            "NewPassword": newPassword
        },
        timeout: 30000,
        success: (data: any, text: string, jqXHR: JQueryXHR) => {
            callback(null);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR));
        }
    });
}

export function updateClientConfiguration(email: string, clientConfiguration: string, callback: (err: RESTError, data: string) => any): void {
    $.ajax(BASE_URL + '/UpdateClientConfiguration', {
        cache: false,
        type: 'POST',
        data: {
            "Email": email,
            "ClientConfiguration": clientConfiguration
        },
        timeout: 30000,
        success: (data: string, text: string, jqXHR: JQueryXHR) => {
            callback(null, data);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR), null);
        }
    });
}

export function getClientConfiguration(email: string, callback: (err: RESTError, data: string) => any): void {
    $.ajax(BASE_URL + '/GetClientConfiguration', {
        cache: false,
        type: 'POST',
        data: {
            "Email": email
        },
        timeout: 30000,
        success: (data: string, text: string, jqXHR: JQueryXHR) => {
            callback(null, data);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR), null);
        }
    });
}

export function updateUser(email: string, region: string, admin: boolean, globalAdmin: boolean,
    metnetSpatialPermissions: MetnetSpatialPermissions,
    digitalWeatherPermissions: DigitalWeatherPermissions,
    userExpiry: number, callback: (err: RESTError) => any): void {
    $.ajax(BASE_URL + '/UpdateUser', {
        cache: false,
        type: 'POST',
        data: {
            "Email": email,
            "Region": region,
            "Admin": admin,
            "GlobalAdmin": globalAdmin,
            "DownloadPermission": DownloadPermissionType.All,
            "UserExpiry": userExpiry,
            "SingleRegionPermission": false,
            "MetnetSpatialPermissions": metnetSpatialPermissions,
            "DigitalWeatherPermissions": digitalWeatherPermissions
        },
        timeout: 30000,
        success: (data: any, text: string, jqXHR: JQueryXHR) => {
            callback(null);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR));
        }
    });
}

export function forgottenPassword(email: string, callback: (err: RESTError) => any): void {
    $.ajax(BASE_URL + '/ForgottenPassword', {
        cache: false,
        type: 'POST',
        data: {
            "Email": email
        },
        timeout: 30000,
        success: (data: any, text: string, jqXHR: JQueryXHR) => {
            callback(null);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR));
        }
    });
}

export function forgottenPassword2Step1(email: string, callback: (err: RESTError) => any): void {
    $.ajax(BASE_URL + '/ForgottenPassword2Step1', {
        cache: false,
        type: 'POST',
        data: {
            "Email": email
        },
        timeout: 30000,
        success: (data: any, text: string, jqXHR: JQueryXHR) => {
            callback(null);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR));
        }
    });
}

export function forgottenPassword2Step2(token: string, email: string, password: string, callback: (err: RESTError) => any): void {
    $.ajax(BASE_URL + '/ForgottenPassword2Step2', {
        cache: false,
        type: 'POST',
        data: {
            "Token": token,
            "NewPassword": password,
            "Email": email
        },
        timeout: 30000,
        success: (data: any, text: string, jqXHR: JQueryXHR) => {
            callback(null);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR));
        }
    });
}

export function verifyUserToken(token: string, minValidityMinutes: number, callback: (err: RESTError, data?: UserTokenValidity) => any): void {
    $.ajax(BASE_URL + '/TokenVerify', {
        cache: false,
        type: 'POST',
        dataType: 'json',
        data: {
            "Token": token,
            "MinValidityMinutes": minValidityMinutes
        },
        timeout: 30000,
        success: (data: UserTokenValidity, text: string, jqXHR: JQueryXHR) => {
            callback(null, data);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR));
        }
    });
}

export function getRegionalAdministrators(callback: (err: RESTError, data?: IRegionalAdministratorsResponse) => any): void {
    $.ajax(BASE_URL + '/GetRegionalAdministrators', {
        cache: false,
        type: 'GET',
        dataType: 'json',
        timeout: 30000,
        success: (data: IRegionalAdministratorsResponse, text: string, jqXHR: JQueryXHR) => {
            callback(null, data);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR));
        }
    });
}